import { createFileRoute } from "@tanstack/react-router";
import { MellanoLuukkuKetMetricsView } from "src/tenantCustomizations/tenants/mellano/views/luukku/metrics/MellanoLuukkuKetMetricsView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/mellano/luukku/ketMetrics")({
	staticData: { title: "Mittaristo, KET", legacyViewKey: "mellanoLuukkuKetMetricsView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <MellanoLuukkuKetMetricsView />;
}
